import { env } from '../env/env';
const SUPPLIER_AGREEMENTS_CONTENT_URL = env.getString('SUPPLIER_AGREEMENTS_CONTENT_URL') || 'https://www.c2fo.dev/api/supplier-agreements';
export const supplierAgreementsApiConfig = {
    SUPPLIER_AGREEMENTS_CONTENT_URL,
};
//# sourceMappingURL=supplierAgreementsApiConfig.js.map